module.exports = __webpack_public_path__ + "static/img/Geos-2022-Danna.7aaa4aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Danna.png
// module id = aLDX
// module chunks = 0